import { createFileRoute } from "@tanstack/react-router";
import MatchCuration from "@/pages/MatchCuration";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/match-curation")({
  head: () => ({
    meta: [
      { title: "Match Curation | Statlign" },
      { name: "description", content: "Statlign match curation console." },
      { property: "og:title", content: "Match Curation | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Statlign match curation console." },
      { name: "twitter:title", content: "Match Curation | Statlign" },
      { name: "twitter:description", content: "Statlign match curation console." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <MatchCuration />
      </ProtectedRoute>
    </MainLayout>
  ),
});
